/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreatePaymarketEligibility } from '../models/CreatePaymarketEligibility';
import type { CreatePaymarketJobEligibility } from '../models/CreatePaymarketJobEligibility';
import type { CreatePaymarketRequest } from '../models/CreatePaymarketRequest';
import type { JobMappingMode } from '../models/JobMappingMode';
import type { PaymarketBase } from '../models/PaymarketBase';
import type { PaymarketGroup } from '../models/PaymarketGroup';
import type { PaymarketListResponseItem } from '../models/PaymarketListResponseItem';
import type { PaymarketOptions } from '../models/PaymarketOptions';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class PaymarketService {

    /**
     * Returns the list of paymarkets for the given user
     * @returns PaymarketListResponseItem Success
     * @throws ApiError
     */
    public static getPayMarketList({
        plan,
        notIndexed,
        includeStats,
        ignorePagination,
        search,
        paymarketGroup,
        ungrouped,
        currencyId,
        surveyId,
        limit,
        offset,
        paymarketIds,
    }: {
        /**
         * Plan ID
         */
        plan?: number,
        /**
         * Indexed filter
         */
        notIndexed?: boolean,
        /**
         * Include paymarket stats
         */
        includeStats?: boolean,
        /**
         * Ignore pagination to fetch all records
         */
        ignorePagination?: boolean,
        /**
         * Search query
         */
        search?: string,
        /**
         * Paymarket group ID
         */
        paymarketGroup?: number,
        /**
         * Filter for all ungrouped paymarkets
         */
        ungrouped?: boolean,
        /**
         * Currency Id
         */
        currencyId?: number,
        /**
         * Survey Id
         */
        surveyId?: string,
        /**
         * Pagination Limit
         */
        limit?: number,
        /**
         * Pagination Offset
         */
        offset?: number,
        /**
         * Ids of paymarket
         */
        paymarketIds?: Array<number>,
    }): CancelablePromise<Array<PaymarketListResponseItem>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/paymarket',
            query: {
                'plan': plan,
                'notIndexed': notIndexed,
                'includeStats': includeStats,
                'ignorePagination': ignorePagination,
                'search': search,
                'paymarketGroup': paymarketGroup,
                'ungrouped': ungrouped,
                'currencyId': currencyId,
                'surveyId': surveyId,
                'limit': limit,
                'offset': offset,
                'paymarketIds': paymarketIds,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Create a new paymarket with all criteria
     * @returns any Success
     * @throws ApiError
     */
    public static addPayMarket({
        requestBody,
    }: {
        requestBody: CreatePaymarketRequest,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/paymarket',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Returns the list of paymarkets base data
     * @returns PaymarketBase Success
     * @throws ApiError
     */
    public static getPayMarketBase({
        search,
    }: {
        /**
         * Search query
         */
        search?: string,
    }): CancelablePromise<Array<PaymarketBase>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/paymarket/base',
            query: {
                'search': search,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Export paymarkets
     * @returns any Success
     * @throws ApiError
     */
    public static exportPayMarkets({
        planId,
    }: {
        /**
         * Plan ID
         */
        planId: number,
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/paymarket/export',
            query: {
                'planId': planId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Returns the list of paymarkets grouped by name
     * @returns PaymarketOptions Success
     * @throws ApiError
     */
    public static getFilter({
        plan,
        uniqName,
        currencyId,
        isIndexed,
        dataModelId,
    }: {
        /**
         * Plan ID
         */
        plan?: Array<number>,
        /**
         * Uniq Name
         */
        uniqName?: boolean,
        /**
         * Currency Id
         */
        currencyId?: number,
        /**
         * Indexed filter
         */
        isIndexed?: boolean,
        /**
         * Data Model Id
         */
        dataModelId?: number,
    }): CancelablePromise<Array<PaymarketOptions>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/paymarket/filter',
            query: {
                'plan': plan,
                'uniqName': uniqName,
                'currencyId': currencyId,
                'isIndexed': isIndexed,
                'dataModelId': dataModelId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Returns the paymarket
     * @returns PaymarketListResponseItem Success
     * @throws ApiError
     */
    public static getPayMarket({
        id,
        includeStats,
    }: {
        /**
         * Paymarket ID
         */
        id: number,
        /**
         * Include paymarket stats
         */
        includeStats?: boolean,
    }): CancelablePromise<PaymarketListResponseItem> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/paymarket/{id}',
            path: {
                'id': id,
            },
            query: {
                'includeStats': includeStats,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Update a paymarket with all criteria
     * @returns any Success
     * @throws ApiError
     */
    public static updatePayMarket({
        id,
        requestBody,
    }: {
        /**
         * Paymarket ID
         */
        id: number,
        requestBody: {
            name?: string;
            locations?: Array<number>;
            groupId?: number | null;
            includeAllJobs?: boolean;
            indexValue?: number | null;
            jobMappingMode?: JobMappingMode;
            eligibility?: Array<CreatePaymarketEligibility>;
            jobEligibility?: Array<CreatePaymarketJobEligibility>;
        },
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/paymarket/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Deelte the paymarket with all critirias
     * @returns any Success
     * @throws ApiError
     */
    public static deletePayMarket({
        id,
    }: {
        /**
         * Paymarket ID
         */
        id: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/paymarket/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Returns the list of paymarket groups for the given user
     * @returns PaymarketGroup Success
     * @throws ApiError
     */
    public static getPayMarketGroupList(): CancelablePromise<Array<PaymarketGroup>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/paymarket/groups',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Create a new paymarket group
     * @returns PaymarketGroup Success
     * @throws ApiError
     */
    public static createPayMarketGroup({
        requestBody,
    }: {
        requestBody: {
            name: string;
        },
    }): CancelablePromise<PaymarketGroup> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/paymarket/groups',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Delete paymarket group
     * @returns any Success
     * @throws ApiError
     */
    public static deletePayMarketGroup({
        id,
    }: {
        /**
         * Paymarket Group ID
         */
        id: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/paymarket/groups/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

}
